import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ReportMetadata, VoluntaryReportMetadata, ReportAttachment, ReportSchedule, ReportStates } from '../models/report.model';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ReportLock } from '../models/report-lock.model';
//import { ObserveOnMessage } from 'rxjs/operators';
//import { observableToBeFn } from 'rxjs/testing/TestScheduler';
import { BehaviorSubject } from 'rxjs';
import { HttpStatusNotifierService } from './http-status-notifier.service';
import { map } from 'rxjs/operators';

@Injectable()
export class ReportdashboardService {
  // endpoint = 'http://localhost:58830/api/Report/';
  endpoint = environment.apiEndpoint + '/ReportSchedule/';

  private bsReportSchedules: BehaviorSubject<ReportSchedule[]>;
  private reportScheduleStore: {
     reportSchedules:ReportSchedule[];
  };

  reportScheduleData: ReportMetadata[];

  constructor(private http: HttpClient,private httpStatusNotifier: HttpStatusNotifierService) {
    this.reportScheduleStore = { reportSchedules: [] };
    this.bsReportSchedules = new BehaviorSubject<ReportSchedule[]>([]);

  }



  getReportSchedule(): Observable<any> {

    if (this.reportScheduleStore.reportSchedules.length === 0) {
      this.getReportScheduleForLoggedInUser();
      }

    return this.bsReportSchedules.asObservable();



  }

  getReportScheduleForLoggedInUser() {
    // console.log('in ReportDashboardService');
    return this.http.get(this.endpoint + 'GetReportSchedulesBasedOnLoggedInUser')
                    .subscribe((data:ReportSchedule[])=>{
                          this.reportScheduleStore.reportSchedules =data;
                          this.bsReportSchedules.next(this.reportScheduleStore.reportSchedules);

                    });
  }


  getReportScheduleById(Id: any): Observable<any> {
    //console.log('In GetReportScheduleByID with Id:' + Id);
    return this.http.get(this.endpoint + 'GetReportScheduleById?id=' + Id);
  }

  saveReportMetadata(reportMetadata: any): Observable<any> {
    this.reportScheduleStore.reportSchedules=[];
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = reportMetadata;
    // return this.http.post('http://localhost:58830/api/ReportSchedule/SaveReportMetadata', body, { headers, observe: 'response' });
    return this.http.post(environment.apiEndpoint + '/ReportSchedule/SaveReportMetadata', body, {
      headers,
      observe: 'response'
    });
  }

  launchReport(Id: any): Observable<any> {
    //console.log('Inside Launch Report method of ReportDashboardService with Id:' + Id);
    return this.http.get(this.endpoint + 'LaunchReport?reportScheduleId=' + Id + '&updateContent=true');
  }
  saveVoluntaryReport$(voluntaryReportMetadata: any): Observable<any> {
    this.reportScheduleStore.reportSchedules=[];
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = voluntaryReportMetadata;
    //console.log(body);
    return this.http.post(environment.apiEndpoint + '/ReportSchedule/SaveVoluntaryReport', body, {
      headers,
      observe: 'response'
    });
  }

  performAction$(id: any, action: string): Observable<any> {
    this.reportScheduleStore.reportSchedules=[];
    const headers = new HttpHeaders().set('content-type', 'application/json');
    //console.log(action + ' ' + this.endpoint);
    if (action == 'SendToPostApprover')
      return this.http.post(this.endpoint + 'SendForPostApprover?reportMetadataId=' + id + '&statusId=' + ReportStates.SubmittedToPostApprover, '', {
        headers,
        observe: 'response'
      });
    else if (action == 'SendCorrectedToPostApprover')
      return this.http.post(this.endpoint + 'SendForPostApprover?reportMetadataId=' + id + '&statusId=' + ReportStates.CorrectedAndSentToApprover, '', {
        headers,
        observe: 'response'
      });
    else if (action == 'PutOnHold')
      return this.http.post(this.endpoint + 'PutReportOnHold?reportMetadataId=' + id, '', {
        headers,
        observe: 'response'
      });
    else if (action == 'UnHoldReport')
      return this.http.post(this.endpoint + 'UnholdReport?reportMetadataId=' + id, '', {
        headers,
        observe: 'response'
      });
    else if (action == 'PublishImmediately')
      return this.http.post(this.endpoint + 'PublishImmediately?reportMetadataId=' + id, '', {
        headers,
        observe: 'response'
      });
    else if (action == 'DeleteReport')
      return this.http.post(this.endpoint + 'DeleteReportById?reportMetadataId=' + id, '', {
        headers,
        observe: 'response'
      });
    else if (action == 'RequestCorrection')
      return this.http.post(this.endpoint + 'UpdateReportState?reportId=' + id + '&reportStateId=' + ReportStates.RequestedForCorrection, '', {
        headers,
        observe: 'response'
      });
  }

  // sendToPostApprover$(id:any):Observable<any>
  // {
  //   const headers = new HttpHeaders().set('content-type', 'application/json');

  //   return this.http.post(this.endpoint+'SendForPostApprover?reportMetadataId='+id,'',{headers, observe: 'response' });
  // }

  // putOnHold$(id:any):Observable<any>
  // {
  //   const headers = new HttpHeaders().set('content-type', 'application/json');

  //   return this.http.post(this.endpoint+'PutReportOnHold?reportMetadataId='+id,'',{headers, observe: 'response' });
  // }
  // unholdReport$(id:any):Observable<any>
  // {
  //   const headers = new HttpHeaders().set('content-type', 'application/json');

  //   return this.http.post(this.endpoint+'UnholdReport?reportMetadataId='+id,'',{headers, observe: 'response' });
  // }

  executeWorkflow$(id: any, mode: string, status: boolean, comments: string,removeAuthor:boolean): Observable<any> {
    this.reportScheduleStore.reportSchedules=[];
    const headers = new HttpHeaders().set('content-type', 'application/json');
    // removeAuthor=((removeAuthor == null)? false: true);
    //TODO: Is there a way to pass the reportmetadata object and the workflow code would find out what step it is in the workflow
    // and what needs to be done next?
    if (mode == 'Approve') {
      const body = [{ reportMetatadataId: id, isAprroved: status, comments: comments,removeAuthor:removeAuthor }];
      return this.http.post(
        this.endpoint +
          'ApproveReturnFromPostApprover?reportMetadataId=' +
          id +
          '&isApproved=' +
          status +
          '&comments=' +
          comments +
          '&removeAuthor='+
          removeAuthor
          ,
        '',
        { headers, observe: 'response' }
      );
    } else {
      const body = [{ reportMetatadataId: id, isValidated: status, comments: comments }];
      return this.http.post(
        this.endpoint +
          'ApproveReturnFromWashington?reportMetadataId=' +
          id +
          '&isValidated=' +
          status +
          '&comments=' +
          comments,
        '',
        { headers, observe: 'response' }
      );
    }
  }

  getReportHistoryById(Id: any): Observable<any> {
    return this.http.get(this.endpoint + 'GetAuditTrailBasedOnReportId?Id=' + Id);
  }

  getLockedReports(): Observable<ReportLock[]> {
    return this.http.get<ReportLock[]>(this.endpoint + 'GetLockedReports');
  }

  checkForLock(Id:any):Observable<boolean>{
     return this.http.get<boolean>(this.endpoint + 'CheckForReportLock?reportId='+Id);
  }

  removeReportLock(reportId: string, token: string) {
    return this.http.get(this.endpoint + 'RemoveReportLock?reportId=' + reportId + '&token=' + token, {
      observe: 'response'
    });
  }

  checkforCommentsandTrackChanges$(reportId:string):Observable<boolean>{
    return this.http.get<boolean>(this.endpoint+'CheckForCommentsAndTrackChanges?reportId=' + reportId);
  }
  downloadPDF$(reportId:any):Observable<any>
  {
     return this.http.get(this.endpoint+"DownloadPublishedReportPDF?reportId="+reportId,{responseType:'blob'}).pipe(map((resp:Blob)=>{
      return new Blob([resp], { type: 'application/pdf' });
     }));
  }


  downloadPDFByFileName$(reportName:any):Observable<any>
  {


     return this.http.get(environment.apiEndpoint+"/Report/DownloadReportByFileName?fileName="+reportName,{responseType:'blob'}).pipe(map((resp:Blob)=>{
      return new Blob([resp], { type: 'application/pdf' });

     }));
  }

  getReportAttachments$(reportId:string):Observable<ReportAttachment[]>{
    return this.http.get<ReportAttachment[]>(environment.apiEndpoint + '/Report/GetReportAttachments?reportId='+reportId);
  }

  // uploadAttachments$(uploadAttachmentList:any[]):Observable<any>{
  //   const headers = new HttpHeaders().set('content-type', 'application/json');
  //   const body = uploadAttachmentList;
  //   console.log(body);
  //   return this.http.post(environment.apiEndpoint + '/Report/UploadAttachments', body, { headers, observe: 'response' });
  // }
  uploadAttachments$(reportMetadataId:string,formData:FormData):Observable<any>
  {
    let url = environment.apiEndpoint+'/Report/UploadAttachments?reportMetadataId='+reportMetadataId;
    return this.http.post(url,formData);

  }

  openAttachment$(Id:number,fileType:string):Observable<any>
  {
    return this.http.get(environment.apiEndpoint+"/Report/GetAttachmentById?Id="+Id,{responseType:'blob'}).pipe(map((resp:Blob)=>{
      return new Blob([resp], { type: 'application/'+fileType });
     }));
  }

  deleteAttachment$(Id:number,reportId:any):Observable<any>
  {

    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = [{ Id: Id,reportId: reportId }];
    return this.http.post(environment.apiEndpoint + '/Report/DeleteAttachment?Id='+Id+'&reportId='+reportId, body, { headers, observe: 'response' });
  }

}
